import { T } from '../styles/tokens';
export function LockOverlay({ locked }: { locked?: boolean }) {
  if (!locked) return null;
  return (
    <div style={{
      position: 'absolute', inset: 0, zIndex: 50,
      background: 'rgba(13,17,23,0.75)', backdropFilter: 'blur(4px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      borderRadius: 12,
    }}>
      <div style={{
        background: `linear-gradient(135deg, ${T.primaryBgSubtle}, ${T.purpleBgSubtle})`,
        border: `1px solid ${T.primaryBgStrong}`,
        borderRadius: 16, padding: '28px 36px', textAlign: 'center', maxWidth: 380,
        boxShadow: `0 8px 32px ${T.blackAlpha40}, 0 0 0 1px ${T.primaryBg}`,
      }}>
        <div style={{
          width: 48, height: 48, borderRadius: 14, margin: '0 auto 16px',
          background: T.primaryBg, display: 'flex', alignItems: 'center', justifyContent: 'center',
          border: `1px solid ${T.primaryBgStrong}`,
        }}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#2F6BFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ animation: 'spin 2s linear infinite' }}>
            <path d="M21 12a9 9 0 1 1-6.219-8.56" />
          </svg>
        </div>
        <div style={{ color: T.text, fontWeight: 700, fontSize: 15, marginBottom: 6, letterSpacing: '-0.3px' }}>
          Ação em andamento
        </div>
        <div style={{ color: '#8B95A5', fontSize: 13, lineHeight: 1.5 }}>
          Aguarde a conclusão antes de fazer alterações.
        </div>
      </div>
    </div>
  );
}
